export const ROOM_STATUS_LABELS = {
  available: "Tersedia",
  reserved: "Dipesan",
  occupied: "Terisi",
  maintenance: "Perbaikan",
  inactive: "Nonaktif",
};

export const ROOM_STATUS_OPTIONS = [
  { value: "available", label: "Tersedia" },
  { value: "reserved", label: "Dipesan" },
  { value: "occupied", label: "Terisi" },
  { value: "maintenance", label: "Perbaikan" },
  { value: "inactive", label: "Nonaktif" },
];

export const ROOM_STATUS_STYLES = {
  available: "bg-emerald-100 text-emerald-700 border-emerald-200",
  reserved: "bg-amber-100 text-amber-700 border-amber-200",
  occupied: "bg-sky-100 text-sky-700 border-sky-200",
  maintenance: "bg-orange-100 text-orange-700 border-orange-200",
  inactive: "bg-muted text-muted-foreground border-border",
};

export function formatRupiah(v) {
  if (v === null || v === undefined || v === "") return "—";
  return "Rp " + Number(v).toLocaleString("id-ID");
}

// --- Period-aware pricing (harian / bulanan / tahunan) ---
export const PERIOD_SUFFIX = { day: "/hari", month: "/bulan", year: "/tahun" };
export const PERIOD_PRICE_KEY = { day: "price_daily", month: "price_monthly", year: "price_yearly" };
export const PERIOD_MIN_KEY = { day: "min_price_daily", month: "min_price_monthly", year: "min_price_yearly" };
export const PERIOD_AVAIL_MIN_KEY = { day: "min_available_daily", month: "min_available_monthly", year: "min_available_yearly" };
const PERIOD_PRIORITY = ["month", "day", "year"];

const _valid = (v) => v !== null && v !== undefined && v !== "" && Number(v) > 0;

// Pick a period: prefer `preferred` if it has a valid price, else priority month->day->year.
export function pickAvailablePeriod(getVal, preferred) {
  if (preferred && _valid(getVal(preferred))) return preferred;
  for (const u of PERIOD_PRIORITY) if (_valid(getVal(u))) return u;
  return null;
}

// Resolve display for a room doc (has price_daily/monthly/yearly).
export function resolveRoomPrice(room, preferred) {
  const unit = pickAvailablePeriod((u) => room?.[PERIOD_PRICE_KEY[u]], preferred);
  if (!unit) return { unit: null, amount: null, suffix: "", label: formatRupiah(null) };
  const amount = room[PERIOD_PRICE_KEY[unit]];
  return { unit, amount, suffix: PERIOD_SUFFIX[unit], label: formatRupiah(amount) };
}

// Resolve display for a search/featured card (has min_price_daily/monthly/yearly + available variants).
export function resolveCardPrice(card, preferred, availableOnly = false) {
  const minKey = availableOnly ? PERIOD_AVAIL_MIN_KEY : PERIOD_MIN_KEY;
  const getVal = (u) => {
    const v = card?.[minKey[u]];
    return _valid(v) ? v : card?.[PERIOD_MIN_KEY[u]]; // fallback to active min if avail missing
  };
  const unit = pickAvailablePeriod(getVal, preferred);
  if (!unit) return { unit: null, amount: null, suffix: "", label: formatRupiah(null) };
  const amount = getVal(unit);
  return { unit, amount, suffix: PERIOD_SUFFIX[unit], label: formatRupiah(amount) };
}
